import React, {Component} from "react";
import {MailroomPhoto} from "../../models/MailroomGetPhotosResult";

interface MailroomPhotoCardProps
{
    mailroomPhoto: MailroomPhoto;
}

interface MailroomPhotoCardState
{
}

export default class MailroomPhotoCard extends Component<MailroomPhotoCardProps,MailroomPhotoCardState>
{

    constructor(props: MailroomPhotoCardProps) {
        super(props);

        this.state = {
        }
    }

 
    public componentDidMount() {
    }
    

    public render() {
        const photoDataUri = "data:image/jpeg;base64," +  this.props.mailroomPhoto.photoBase64;

        return (
            <div className="mailroom-photo-card">
                
                <div className={"mailroom-photo-card__photo"} style={{
                    backgroundImage: `url(${photoDataUri})`,
                }}/>
                
                <div className={"mailroom-photo-card__title"}>
                    {this.props.mailroomPhoto.email}
                </div>
            </div>
        );
    }
}